import { useRef, useState, useEffect } from 'react'

export const useScrollableRails = (items = []) => {
  const scrollContainerRef = useRef(null)
  // State to track scroll position and whether content is scrollable
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const [hasScrollableContent, setHasScrollableContent] = useState(false)

  // Function to check scroll position and update state
  const updateScrollState = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current
      const scrollLeft = container.scrollLeft
      const scrollWidth = container.scrollWidth
      const clientWidth = container.clientWidth
      // Check if content is scrollable
      const isScrollable = scrollWidth > clientWidth
      setHasScrollableContent(isScrollable)
      // Check if can scroll left (not at the beginning)
      setCanScrollLeft(scrollLeft > 0)
      // Check if can scroll right (not at the end)
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1) // -1 for rounding errors
    }
  }

  // Update scroll state when component mounts and when items change
  useEffect(() => {
    // Small delay to ensure DOM is updated
    const timeoutId = setTimeout(() => {
      updateScrollState()
    }, 10)
    // Add resize observer to update scroll state when container size changes
    const resizeObserver = new ResizeObserver(() => {
      updateScrollState()
    })
    if (scrollContainerRef.current) {
      resizeObserver.observe(scrollContainerRef.current)
    }
    return () => {
      clearTimeout(timeoutId)
      resizeObserver.disconnect()
    }
  }, [items])

  const scrollLeft = () => {
    if (scrollContainerRef.current && canScrollLeft) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' })
    }
  }

  const scrollRight = () => {
    if (scrollContainerRef.current && canScrollRight) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' })
    }
  }

  return {
    scrollContainerRef,
    canScrollLeft,
    canScrollRight,
    hasScrollableContent,
    scrollLeft,
    scrollRight,
    updateScrollState
  }
}
